<template>
    <div class="hero-software hero-swiper-btn" id="home">
        <div class="container_f1">
            <div class="swiper-wrapper">
                <swiper :options="swiperOption">
                    <div class="swiper-slide" :style="bgImg">
                        <div class="hero-item">
                            <div class="hero-content">
                                <h2 class="h1 hero-content-title">{{ $t('slogan1') }}</h2>
                                <h6 class="hero-content-subtitle">{{ $t('slogan') }}</h6>
                                
                                <ul class="footer-widget__list">
                                <li>
                                    <router-link :to="{ path: '/contacts' }" class="btn btn--green">
                                    <span class="btn-icon  ml-0 mr-2"><i class="fa fa-arrow-alt-to-bottom"></i></span>{{ $t('ucretsizdene') }}
                                </router-link>
                                </li>
                                <span>
                                <li class="btn btn--green">
                                <a href="https://apps.apple.com/tr/app/karpin-mobil/id6443685147?l=tr" target="_blank" ><i class="fab fa-apple social-link-icon"></i> App Store {{$t('indir')}}</a>
                                </li>
                                </span>
                                <span>
                                <li class="btn btn--green">
                                <a href="https://play.google.com/store/apps/details?id=com.karpin.mobile" target="_blank"><i class="fab fa-android social-link-icon"></i> GooglePlay {{$t('indir')}}</a>
                                </li>
                                </span>
                                </ul>
                            </div>
                            <div class="hero-thumb pr-100">
                                <img src="../assets/img/hero/hero-software/software-thumb-1.webp" class="img-fluid" alt="karpin" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide" :style="bgImg">
                        <div class="hero-item">
                            <div class="hero-content">
                                <h2 class="h1 hero-content-title">{{ $t('slogan2') }}</h2>
                                <h6 class="hero-content-subtitle">{{ $t('slogan4') }}</h6>
                                <router-link :to="{ path: '/contacts' }" class="btn btn--green">
                                    <span class="btn-icon  ml-0 mr-2"><i class="fa fa-arrow-alt-to-bottom"></i></span> {{ $t('ucretsizdene') }}
                                </router-link>
                            </div>
                            <div class="hero-thumb">
                                <img src="../assets/img/hero/hero-software/software-thumb-2.webp" class="img-fluid" alt="karpin" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide" :style="bgImg">
                        <div class="hero-item">
                            <div class="hero-content">
                                <h2 class="h1 hero-content-title">{{ $t('slogan3') }}</h2>
                                <h6 class="hero-content-subtitle">{{ $t('slogan5') }}</h6>
                                <router-link :to="{ path: '/contacts' }" class="btn btn--green">
                                    <span class="btn-icon  ml-0 mr-2"><i class="fa fa-arrow-alt-to-bottom"></i></span> {{ $t('ucretsizdene') }}
                                </router-link>
                            </div>
                            <div class="hero-thumb pr-100">
                                <img src="../assets/img/hero/hero-software/software-thumb-3.webp" class="img-fluid" alt="karpin" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <!-- Optional controls -->
                    <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                    <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                bgImg: {
                    backgroundImage: `url(${require("../assets/img/hero/hero-software/software-shape.png")})`
                },
                swiperOption: {
                    speed: 1500,
                    loop: true,
                    effect: 'fade',
                    autoplay: false,
                    spaceBetween : 30,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                }
            };
        }
    };
</script>

<style lang="scss" scoped> 
    @import '../assets/scss/variabls.scss';
    @import '../assets/scss/elements/hero-software.scss';
</style>
